import { Accordion as MUIAccordion, AccordionProps as MUIAccordionProps } from '@mui/material';
import { mergeSX } from '../../services/helpers';
import { boxShadow2 } from '../../theme';

export {
  default as AccordionDetails,
  type IAccordionDetailsProps,
} from './components/AccordionDetails';
export {
  default as AccordionSummary,
  type IAccordionSummaryProps,
} from './components/AccordionSummary';

export interface IAccordionProps extends MUIAccordionProps {
}

const buildSX = () => ({
  '&:before': {
    display: 'none',
  },
  '&.MuiAccordion-rounded': {
    borderRadius: 4,
    boxShadow: boxShadow2,
  },
});

const Accordion = (props: IAccordionProps) => {
  const { sx, children, ...restProps } = props;

  return (
    <MUIAccordion
      sx={mergeSX(buildSX(), sx)}
      {...restProps}
    >
      {children}
    </MUIAccordion>
  );
};

export default Accordion;
